import React, { createContext, useState, useCallback, useContext } from 'react';
import { isInIframe } from 'config/system';
import { PageType, SetPage, IPageService } from './types';

const PageContext = createContext<PageType>('index');
const SetPageContext = createContext<SetPage>(() => {});

/**
 * The service of page.
 *
 * @example
 *
 * <PageService>
 * 	{...}
 * </PageService>
 *
 * const page = PageService.usePage();
 * const setPage = PageService.useSetPage();
 *
 * setPage('password');
 */
export const PageService: IPageService = ({ children }) => {
  const [page, originalSetPage] = useState<PageType>('index');
  const setPage = useCallback<SetPage>(newPage => {
    originalSetPage(newPage);

    /**
     * Post message to the parent window if embeded.
     */
    if (isInIframe) {
      window.parent.postMessage({ type: 'CHANGE_PAGE', payload: newPage }, '*');
    }
  }, []);

  return (
    <SetPageContext.Provider value={setPage}>
      <PageContext.Provider value={page}>{children}</PageContext.Provider>
    </SetPageContext.Provider>
  );
};

const usePage = () => useContext(PageContext);
const useSetPage = () => useContext(SetPageContext);

PageService.usePage = usePage;
PageService.useSetPage = useSetPage;
